export default __webpack_public_path__ + "images/8791ce567edc492ef5cd5f41d340e26e-underwave.png";